import { RootState } from '@/store'

export const getUserPool = (state: RootState) => {
  return state.context.organization.userPool
}
